export const getRandomId = (): string => `AppFleebeId__${window.crypto.randomUUID()}`;
